function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as actionTypes from "../../actions/lp/actionTypes";
import { pageRoutes } from "../../routes";
import { getAuthorizedServiceProvidersState } from "../../utils/entityPicker";
import { mapPermissionsToTerms } from "../../utils/mapPermissionsToTerms";
export var initialState = {
    authorizedEntities: {},
    authorizedLps: null,
    authorizedDSPs: null,
    lpSelected: null,
    lpPickerInput: ""
};
export function lpReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var type = action.type, payload = action.payload;
    switch(type){
        case actionTypes.GET_AUTHORIZED_LPS_SUCCESS:
            {
                var serviceProvidersList = payload.serviceProvidersList, serviceProviderIdentifierType = payload.serviceProviderIdentifierType;
                return _object_spread_props(_object_spread({}, state), _define_property({}, getAuthorizedServiceProvidersState(serviceProviderIdentifierType), serviceProvidersList));
            }
        case actionTypes.GET_AUTHORIZED_LPS_FAILURE:
            return _object_spread_props(_object_spread({}, state), {
                authorizedLps: []
            });
        case actionTypes.GET_AUTHORIZED_ENTITIES_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                authorizedEntities: mapPermissionsToTerms(payload.permissionToEntitiesMap)
            });
        case actionTypes.GET_AUTHORIZED_LP_SELECTED_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                lpSelected: payload
            });
        case actionTypes.GET_AUTHORIZED_LP_SELECTED_FAILURE:
            {
                window.location.pathname = pageRoutes.PICKER_PAGE; // If user is unAuthorized for any reason, he should be navigated to /global-picker page for AuthZ
                return state;
            }
        case actionTypes.SET_LP_PICKER_INPUT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    lpPickerInput: action.payload
                });
            }
        default:
            return state;
    }
}

//# sourceMappingURL=index.js.map